// extracted by mini-css-extract-plugin
export default {"container":"Rate_container__-D94v"};